var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardFaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94616 5.99999L0.873087 1.92689C0.734621 1.78844 0.663787 1.6144 0.660587 1.40479C0.657371 1.19519 0.728204 1.01795 0.873087 0.873087C1.01795 0.728203 1.19359 0.655762 1.39999 0.655762C1.60639 0.655762 1.78202 0.728203 1.92689 0.873087L6.42111 5.36731C6.51471 5.46089 6.58074 5.55961 6.61919 5.66346C6.65765 5.76729 6.67689 5.87947 6.67689 5.99999C6.67689 6.1205 6.65765 6.23268 6.61919 6.33651C6.58074 6.44036 6.51471 6.53908 6.42111 6.63266L1.92689 11.1269C1.78844 11.2654 1.6144 11.3362 1.40479 11.3394C1.19519 11.3426 1.01795 11.2718 0.873087 11.1269C0.728204 10.982 0.655762 10.8064 0.655762 10.6C0.655762 10.3936 0.728204 10.218 0.873087 10.0731L4.94616 5.99999Z",
    fill: "#C6C6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardFaded);
export default __webpack_public_path__ + "static/media/ForwardFaded.858447e5c68d99d154ff2392f8f498b2.svg";
export { ForwardRef as ReactComponent };